import { _isEmptyString } from '@/littledash';

/** Maximum number of animals allowed per cage */
export const MAX_CAGE_POPULATION = 15;

/** Mirrors the server's message so a value rejected client-side reads the same as a 400 would */
export const CAGE_ANIMAL_COUNT_OUT_OF_RANGE = `Animals per cage must be between 1 and ${MAX_CAGE_POPULATION}`;

/** Maximum character length for cage names */
export const MAX_CAGE_NAME_LENGTH = 50;

/** Validates that a cage name is non-empty and within the maximum length */
export const cageNameValidator = (value: string) =>
  !_isEmptyString(value ?? '') && value.length <= MAX_CAGE_NAME_LENGTH;
